// extracted by mini-css-extract-plugin
module.exports = {"news_section":"news-module--news_section--2yMSq"};